












import Vue from 'vue';
import CandidateService from '~/services/CandidateService';
import {
    CandidateJobBuilder,
    CandidateJobBuilderChangeEvent,
    commonProps,
    setupBuilder,
} from '~/utils/candidate';
import LanguagesForm from '../forms/LanguagesForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'LanguagesModal',
    props: {
        show: {
            type: Boolean,
            required: true,
        },

        ...commonProps(),
    },
    components: {
        ProfileModal,
        LanguagesForm,
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            isLoading: false,
            hasUnsavedChanges: false,
        };
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        async handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();

            this.isLoading = true;
            await this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('close');
                })
                .catch(() => {
                    this.isLoading = false;
                });
            this.builder.reset();
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
